// Empty shim for react-native-sqlite-storage
// This module is only used by TypeORM's React Native driver, which is not used in this project
module.exports = {};
